import type { Client, RequestContext } from "../client";
import type { RouteArgs } from "../resolver";
import type { GetAllTenantTagSetsAcrossAllSpacesBffResponse, TagSetResource } from "../resources/tagSetResource";
import type { ListArgs } from "./basicRepository";
import { BasicRepository } from "./basicRepository";
export type TagSetListArgs = ListArgs & RouteArgs & {
    partialName?: string;
};
export class TagSetRepository extends BasicRepository<TagSetResource, TagSetResource, TagSetListArgs> {
    constructor(client: Client, requestContext: RequestContext) {
        super("TagSets", client, requestContext);
    }
    sort(ids: string[]) {
        return this.client.put(this.requestContext, this.client.getLink("TagSetSortOrder"), ids);
    }
    allTagSetsAcrossAllSpaces(args?: {
        filterBySpace?: string;
        filterByExcludedSpace?: string;
    }): Promise<GetAllTenantTagSetsAcrossAllSpacesBffResponse> {
        return this.client.get<GetAllTenantTagSetsAcrossAllSpacesBffResponse>(this.requestContext, "~/bff/tenants/tagSets{?filterBySpace,filterByExcludedSpace}", args);
    }
    getAllByScopes(scopes: string[]): Promise<TagSetResource[]> {
        return this.all();
    }
}
